module.exports = __webpack_public_path__ + "static/media/google-pay.229230da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/google-pay.svg
// module id = 884
// module chunks = 7